import React, { useEffect, useState } from "react";
import { object } from "prop-types";
import get from "lodash/get";

import AuthorDetails from "../../../molecules/AuthorDetails";
import NewsHeadline from "../../../atoms/NewsHeadline";
import Excerpt from "../../../atoms/Excerpt";

import { getExcerpt } from "../../../utils/utils";
import { getAuthorObj } from "../../../helper/api";

import "./organism1.m.css";

const Organism1 = ({ story: { story } }) => {
  const storyObj = story;
  const authorObj = get(storyObj, ["authors", 0], "");
  const excerpt = getExcerpt(story);
  const authorDisplayName = get(storyObj, ["metadata", "story-attributes", "author-display-name", "0"], null);
  const hideAuthorName = get(storyObj, ["metadata", "story-attributes", "hideauthor", 0], "no");
  const [author, setAuthor] = useState([]);

  const firstAuthor = async (authorId) => {
    if (authorId) {
      const data = await getAuthorObj(authorId);
      setAuthor((author) => [...author, data]);
    }
  };
  useEffect(() => {
    firstAuthor(authorObj.id);
  }, []);
  return (
    <div styleName="base" className="base organism1">
      <NewsHeadline story={storyObj} cssStyleName="bigSize" />
      {excerpt && <Excerpt excerpt={excerpt} excerptLink={storyObj.url} />}
      {hideAuthorName === "no" && (
        <AuthorDetails
          story={storyObj}
          authors={author}
          authorDisplayName={authorDisplayName}
          withAvatar={true}
          contributorType={2}
          authorDetailsType={"opinion-stories-author-details"}
          location={true}
        />
      )}
    </div>
  );
};

Organism1.propTypes = {
  story: object.isRequired,
};

export default Organism1;
